import AlertRibbon from "./AlertRibbon";
import { RibbonProps } from "./types";

const SuccessRibbon = ({ data }: RibbonProps) => {
  const { details, setAlert } = data;

  if (details && details.type === "success") {
    return (
      <AlertRibbon
        handleClose={() => setAlert(null)}
        severity={details.type}
        message={details.message}
        errorCode={details.errorCode}
      />
    );
  }
  return null;
};

export default SuccessRibbon;
